import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// $FlowFixMe
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from 'app/components/Icons';
import { BurgerButton } from 'app/components/Icons/BurgerButton/BurgerButton.jsx';
import { HorizontalCollapse } from 'app/components/Transitions/HorizontalCollapse.jsx';
import history from 'app/main/routerHistory';
import { MenuContext } from 'app/main/Authenticated/Authenticated';
import classes from 'app/main/Authenticated/Header/Header.module.scss';
import User from 'app/main/Authenticated/Header/User';
import IconsNav from 'app/main/Authenticated/Header/IconsNav.jsx';
import SearchingBar from 'app/main/Authenticated/Header/SearchingBar/SearchingBar';
import Nav from 'app/main/Authenticated/Header/Nav';
export function Header() {
    const menuContextConsumer = useContext(MenuContext);
    function displayBurgerButton() {
        const location = history.location.pathname.split('/');
        if (location[1] === 'admin')
            return true;
        if (location[1] === 'notifications')
            return true;
        if (location[1] === 'hr')
            return true;
        if (location[1] === 'projects') {
            if (location[2])
                return true;
        }
        return false;
    }
    return (_jsx("div", { className: classes.container, children: _jsxs("header", { className: classes.header, children: [_jsx(HorizontalCollapse, { open: displayBurgerButton(), width: 50, children: _jsx("div", { className: classes.burgerButton, children: _jsx(BurgerButton, { onClick: menuContextConsumer.toggleMenu, open: menuContextConsumer.isOpen }) }) }), _jsx(Link, { className: classes.name, to: "/", children: _jsx(Logo, { className: classes.logo }) }), _jsx(Nav, {}), _jsx(SearchingBar, {}), _jsx(IconsNav, {}), _jsx(User, {})] }) }));
}
